//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'InFlightPaO2',
  data () {
    return {
      defaultJson:{
        "PaCO": "PaCO₂",
        "In-Flight PaO₂": "In-Flight PaO₂",
        "PaO₂": "PaO₂",
        "Simulated Altitude": "Cabin Altitude",
        "Supplemental oxygen recommended": "Supplemental oxygen recommended",
        "altitudeHint": "During air travel, cabin pressures are generally maintained to simulate an altitude of about 8000 feet (2438 m)."
      },
      form: {
        po2:'',
        pco2:'',
        alt:'8000',
      },
      dataList1: [
        {value: '-1"', name: '无 PET 影像',shortName:'无影像'},
        {value: '0', name: '无摄取',shortName:'无'},
        {value: '2.322', name: '少量摄取',shortName:'少量'},
        {value: '4.617', name: '中度摄取',shortName:'中度'},
        {value: '4.771', name: '高度摄取',shortName:'高度'},
      ],
      hasScore: false,
      disabled: false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // 1.59 + (0.98*po2) + (0.0031*alt) - (0.000061*po2*alt) - (0.000065*pco2*alt) + (0.000000092*alt*alt)

        //  form.
        let result =	1.59 + (0.98*form.po2) + (0.0031*form.alt) - (0.000061*form.po2*form.alt) - (0.000065*form.pco2*form.alt) + (0.000000092*form.alt*form.alt)
        self.hasScore = true
        if (result < 55) {
          self.descTxt ='Supplemental oxygen recommended'
        }
        return String(result.toFixed(0))
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/InFlightPaO2.vue